<template>
	<v-card class="elevation-0">
		<v-card-text style="padding-bottom: 0; border: 1px solid #185EA91A; background-color: #E7EEF6;">
			<v-container fluid class="px-2 pt-1 pb-2">
				<v-row v-if="readOnly" class="mt-1 mb-6 px-1 d-flex justify-space-between align-center">
					<v-col cols="12" class="py-0 px-2 d-flex justify-space-between align-center">
						<span style="font-size: 20px;" class="black--text">{{ selectedPlan }}</span>
						<span style="font-size: 20px;" class="black--text">{{ renewalDate }}</span>
					</v-col>
				</v-row>
				<v-row class="my-0 d-flex justify-space-between align-start" style="border-bottom: 1px solid #185EA91A;">
					<v-col cols="6" class="py-0">
						<span style="font-size: 16px; color: black;" class="d-block font-weight-bold">
							{{ $t('wkt.admin.license.upgrade-account-window.step-2.license-items.employees') }}
						</span>
						<span style="font-size: 14px;" class="d-block">
							{{ employeePricePerMonth }}
						</span>						
					</v-col>
					<v-col cols="2" style="height: 80px;">
						<span style="font-size: 14px;" class="d-block">
							{{ $t('wkt.admin.license.upgrade-account-window.employees') }}
						</span>
						<v-text-field 
						hide-details
						v-model="numEmployees"
						:readonly="readOnly"
						@keydown.prevent
						@input="$emit('employees-changed', parseInt($event))"
						class="ma-0 pa-0"
						type="number" 
						step="1"
						:min="minEmployees" />
					</v-col>
				</v-row>
				<v-row class="my-4 d-flex justify-space-between align-start" style="border-bottom: 1px solid #185EA91A;">
					<v-col cols="6" class="py-0">
						<span style="font-size: 16px; color: black;" class="d-block font-weight-bold">
							{{ $t('wkt.admin.license.upgrade-account-window.step-2.license-items.storage_documents') }}
						</span>
						<span style="font-size: 14px;" class="d-block">{{ storageQuantityPerPlan }}</span>
						<span style="font-size: 14px;" class="d-block">{{ storagePricePerMonth }}</span>					
					</v-col>
					<v-col cols="2" style="height: 80px;">
						<span style="font-size: 14px;" class="d-block">
							{{ $t('wkt.admin.license.upgrade-account-window.step-2.license-items.storage') }}
						</span>
						<v-text-field 
						hide-details
						v-model="numStorage"
						:readonly="readOnly" 
						@keydown.prevent
						@input="$emit('storage-changed', parseInt($event))"
						class="ma-0 pa-0"
						type="number" 
						step="1"
						:min="minStorage" />			
					</v-col>
				</v-row>
				<v-row v-if="showSignatures" class="my-4 d-flex justify-space-between align-start" style="border-bottom: 1px solid #185EA91A;">
					<v-col cols="6" class="py-0">
						<span style="font-size: 16px; color: black;" class="d-block font-weight-bold">
							{{ $t('wkt.admin.license.upgrade-account-window.step-2.license-items.signature_sms') }}
						</span>
						<span style="font-size: 14px;" class="d-block">{{ signaturePricePerUnit }}</span>					
					</v-col>
					<v-col cols="2" style="height: 80px;">
						<span style="font-size: 14px;" class="d-block">
							{{ $t('wkt.admin.license.upgrade-account-window.step-2.license-items.signature') }}
						</span>
						<v-text-field 
						hide-details
						v-model="numSignatures"
						:readonly="readOnly" 
						@keydown.prevent
						@input="$emit('signatures-changed', parseInt($event))"
						class="ma-0 pa-0"
						type="number" 
						step="1"
						:min="minSignatures" />
					</v-col>
				</v-row>
				<v-row v-if="readOnly" class="mt-0 pt-0 pb-2">
					<v-col class="pa-0">
						<AddVoucher @voucher-used="$emit('add-voucher', $event)" />
					</v-col>
				</v-row>
			</v-container>
		</v-card-text>
	</v-card>
</template>

<script>
import BaseModule from '../../../common/BaseModule.js';
import PurchaseUtils from './PurchaseUtils.js';
import AddVoucher from './AddVoucher';

export default {
    name: 'LicenseItems',
    mixins: [BaseModule, PurchaseUtils],
	props: ['company','licensingInfo','licenseType','licensePlan','planEmployees','planStorage','planSignatures','autorenew','renewDate','readOnly','upgrade'],
	//props: ['company','licensingInfo','licenseType','licensePlan','planEmployees','planStorage','planSignatures','minEmployees','minStorage','minSignatures','autorenew','renewDate','readOnly'],
	watch: {
		planEmployees: {
			immediate: true,
			deep: true,
			// eslint-disable-next-line no-unused-vars
			handler(newValue, oldValue) {
				this.numEmployees = newValue;
			}
		},		
		planStorage: {
			immediate: true,
			deep: true,
			// eslint-disable-next-line no-unused-vars
			handler(newValue, oldValue) {
				this.numStorage = parseInt(newValue);
			}
		},
		planSignatures: {
			immediate: true,
			deep: true,
			// eslint-disable-next-line no-unused-vars
			handler(newValue, oldValue) {
				this.numSignatures = newValue;
			}
		}
	},
	components: {
		AddVoucher
	},
    data () {
		return {
			numEmployees: 0,
			numStorage: 0, 
			numSignatures: 0,
			minEmployees: 0,
			minStorage: 0,
			minSignatures: 0,
		}
    },
	mounted() {
		console.log(`*** LicenseItems.upgrade: ${this.upgrade}`);

		if (this.readOnly) {
			return;
		}

		const planEmployees = this.calculatePlanEmployees(this.company);
		const planStorage = this.calculatePlanStorage(this.company, this.licensingInfo, this.licenseType, this.licensePlan);
        const planSignatures = this.calculatePlanSignatures(this.company, this.licensingInfo, this.licenseType, this.licensePlan, this.numSignatures);
		
		this.numEmployees = parseInt(planEmployees.num);
		this.minEmployees = parseInt(planEmployees.min);

		this.numStorage = parseInt(planStorage.num);
		this.minStorage = parseInt(planStorage.min);

		this.numSignatures = parseInt(planSignatures.num);
		this.minSignatures = parseInt(planSignatures.min);
		
		/*this.numEmployees = Math.max(this.company.currentSeats, this.company.currentSeatLimit);
		this.numStorage = Math.floor(this.company.currentStorageLimit / 1024);

		// Valor mínimo
		this.minEmployees = Math.max(this.company.currentSeats, this.company.currentSeatLimit);

		const license = this.findLicenseSKU(this.licensingInfo, this.constants.STORAGE_MB, this.licenseType, this.licensePlan, this.constants.LICENSE_CLASS_BASE);

		let storage = this.numStorage;

		if (license && license.quantity > storage) {
			storage = license.quantity;
		}

		this.numStorage = storage;

		// Valor mínimo
		storage = this.company.currentStorageLimit;

		if (license && license.quantity > storage) {
			storage = license.quantity;
		}

		this.minStorage = storage / 1024;

		// Firmas
		const item = this.findStockSKU(this.licensingInfo, this.constants.SMS_SIGNATURE, this.licenseType, this.licensePlan, this.constants.LICENSE_CLASS_BASE);

		let signatures = this.numSignatures;

		if (item && item.quantity > signatures) {
			signatures = item.quantity;
		}

		this.numSignatures = signatures;
		
		// Valor mínimo
		this.minSignatures = item.quantity;*/

		this.$emit('employees-changed', this.numEmployees);
		this.$emit('storage-changed', this.numStorage);
		//this.$emit('signatures-changed', this.numSignatures);
	},
	computed: {
		selectedPlan() {
			if (!this.company) {
				return '???';
			}

			let text = '';

			switch (this.licenseType) {
				case this.constants.LICENSE_TYPE_FREE: 
					text = this.$t('wkt.admin.license.type-free-description');
					break;
				case this.constants.LICENSE_TYPE_BUSINESS: 
					text = this.$t('wkt.admin.license.type-business-description');
					break;
				case this.constants.LICENSE_TYPE_CORPORATE: 
					text = this.$t('wkt.admin.license.type-corporate-description');
					break;
			}

			text += ' - ';

			switch (this.licensePlan) {
				case this.constants.LICENSE_PLAN_FREE: 
					text += this.$t('wkt.admin.license.plan-free-description');
					break;
				case this.constants.LICENSE_PLAN_MONTHLY:
					text += this.$t('wkt.admin.license.plan-monthly-description');
					break;
				case this.constants.LICENSE_PLAN_ANNUAL: 
					text += this.$t('wkt.admin.license.plan-annual-description');
					break;
			}

			return text;
		},
		renewalDate() {
			if (!this.company && !this.renewDate) {
				return '???';
			}
			
			let date;

			if (this.renewDate) {
				date = this.renewDate;
			} else {
				date = this.company.licensePlanExpires;
			}

			let text = this.formatOnlyDate(date);
			
			text += ' - ';

			/*let auto;

			if (this.renewDate) {
				auto = this.autorenew;
			} else {
				auto = this.company.licensePlanAutonrenew;
			}*/

			if (this.autorenew) {
				text += this.$t('wkt.admin.license.plan.renew.automatic');
			} else {
				text += this.$t('wkt.admin.license.plan.renew.manual');
			}

			return text;
		},
		employeePricePerMonth() {
			if (this.licensingInfo === null || this.licenseType === null || this.licensePlan === null) {
				return '???';
			}

			const licenseClass = this.licenseType === this.constants.LICENSE_TYPE_FREE ? this.constants.LICENSE_CLASS_BASE : this.constants.LICENSE_CLASS_EXTENSION;

			const license = this.findLicenseSKU(this.licensingInfo, this.constants.ACTIVE_EMPLOYEES, this.licenseType, this.licensePlan, licenseClass);
			
			if (!license) {
				return '';
			}

			let description = 'wkt.admin.license-SKU.additional-employee';

			switch (this.licenseType) {
				case this.constants.LICENSE_TYPE_FREE:
					description += '.free';
					break;
				case this.constants.LICENSE_TYPE_BUSINESS:
					description += '.business';
					break;
				case this.constants.LICENSE_TYPE_CORPORATE:
					description += '.corporate';
					break;
			}

			switch (this.licensePlan) {
				case this.constants.LICENSE_PLAN_MONTHLY:
					description += '.monthly';
					break;
				case this.constants.LICENSE_PLAN_ANNUAL:
					description += '.annual';
					break;
			}
			
			return this.$t(description);

			//return license.description;
				
			/*let text = license.price.toFixed(2);
			text += this.$t('wkt.admin.license.upgrade-account-window.step-2.license-items.employee_price_per_month');

			return text;*/
		},
		storageQuantityPerPlan() {
			if (this.licensingInfo === null || this.licenseType === null || this.licensePlan === null) {
				return '???';
			}

			//const licenseClass = this.licenseType === this.constants.LICENSE_TYPE_FREE ? this.constants.LICENSE_CLASS_BASE : this.constants.LICENSE_CLASS_EXTENSION;

			let license = this.findLicenseSKU(this.licensingInfo, this.constants.STORAGE_MB, this.licenseType, this.licensePlan, this.constants.LICENSE_CLASS_BASE);
			
			if (!license) {
				return '';
			}

			let description = 'wkt.admin.license-SKU.storage';

			switch (this.licenseType) {
				case this.constants.LICENSE_TYPE_FREE:
					description += '.free';
					break;
				case this.constants.LICENSE_TYPE_BUSINESS:
					description += '.business';
					break;
				case this.constants.LICENSE_TYPE_CORPORATE:
					description += '.corporate';
					break;
			}

			switch (this.licensePlan) {
				case this.constants.LICENSE_PLAN_MONTHLY:
					description += '.monthly';
					break;
				case this.constants.LICENSE_PLAN_ANNUAL:
					description += '.annual';
					break;
			}
			
			return this.$t(description);

			//return license.description;

			/*let text = license.quantity;
			text += this.$t('wkt.admin.license.upgrade-account-window.step-2.license-items.storage_quantity_per_plan');

			license = this.findLicenseSKU(this.licensingInfo, this.constants.STORAGE_MB, this.licenseType, this.licensePlan, this.constants.LICENSE_CLASS_EXTENSION);
			
			if (!license) {
				return text;
			}
				
			text += ' / ';
			text += license.price.toFixed(2);
			text += this.$t('wkt.admin.license.upgrade-account-window.step-2.license-items.storage_price_per_plan');

			return text;*/
		},
		storagePricePerMonth() {
			if (this.licensingInfo === null || this.licenseType === null || this.licensePlan === null) {
				return '???';
			}

			const license = this.findLicenseSKU(this.licensingInfo, this.constants.STORAGE_MB, this.licenseType, this.licensePlan, this.constants.LICENSE_CLASS_EXTENSION);
			
			if (!license) {
				return '';
			}

			let description = 'wkt.admin.license-SKU.additional-storage';

			switch (this.licenseType) {
				case this.constants.LICENSE_TYPE_FREE:
					description += '.free';
					break;
				case this.constants.LICENSE_TYPE_BUSINESS:
					description += '.business';
					break;
				case this.constants.LICENSE_TYPE_CORPORATE:
					description += '.corporate';
					break;
			}

			switch (this.licensePlan) {
				case this.constants.LICENSE_PLAN_MONTHLY:
					description += '.monthly';
					break;
				case this.constants.LICENSE_PLAN_ANNUAL:
					description += '.annual';
					break;
			}
			
			return this.$t(description);

			//return license.description;

			/*let text = license.quantity;
			text += this.$t('wkt.admin.license.upgrade-account-window.step-2.license-items.storage_quantity_additional');

			return text;*/
		},
		signaturePricePerUnit() {
			if (this.licensingInfo === null || this.licenseType === null || this.licensePlan === null) {
				return '???';
			}
			
			const stock = this.findStockSKU(this.licensingInfo, this.constants.SMS_SIGNATURE, this.licenseType, this.licensePlan, this.constants.LICENSE_CLASS_EXTENSION);
			
			if (!stock) {
				return '';
			}

			let description = 'wkt.admin.stock-SKU.signatures';

			switch (this.licenseType) {
				case this.constants.LICENSE_TYPE_FREE:
					description += '.free';
					break;
				case this.constants.LICENSE_TYPE_BUSINESS:
					description += '.business';
					break;
				case this.constants.LICENSE_TYPE_CORPORATE:
					description += '.corporate';
					break;
			}

			switch (this.licensePlan) {
				case this.constants.LICENSE_PLAN_MONTHLY:
					description += '.monthly';
					break;
				case this.constants.LICENSE_PLAN_ANNUAL:
					description += '.annual';
					break;
			}
			
			return this.$t(description);

			//return stock.description;			

			/*let text = stock.price.toFixed(2);
			text += this.$t('wkt.admin.license.upgrade-account-window.step-2.license-items.signature_price_per_unit');

			return text;*/
		},
		showSignatures() {
			return false; //this.upgrade && this.company.licenseType === this.constants.LICENSE_TYPE_FREE;
		}
	},
    methods: {
    },
}
</script>